const currencyCode = document.body.getAttribute('data-currency-code');
const symbol = document.body.getAttribute('data-currency-symbol');

export  const currency = (money) => {
    return `${symbol}${(money / 100).toFixed(2)} ${currencyCode}`;
}

export const currencyWithoutSymbol = (money) => {
    return `${(money / 100).toFixed(2)}`;
}